import { useMutation } from "react-query";
import { authInstance } from "apis";

interface Params {
  onSuccess: (result: string) => void;
}

const useUpload = ({ onSuccess }: Params) => {
  const fetcher = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await authInstance.post("upload", formData);
    return data;
  };

  const { mutate } = useMutation(fetcher, {
    onSuccess: (result) => {
      onSuccess(result);
    },
  });

  return mutate;
};

export default useUpload;
